import React, { useEffect, useState } from "react";
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper/modules";
import noimage from "../../Assets/images/no-image-found.jpg";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { api_url } from "../../Constants/web_services";
import { Link } from "react-router-dom";

const HomeCompanies = () => {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    fetch(api_url + "/api/companies")
      .then((response) => response.json())
      .then((companies) => {
        setCompanies(companies?.data);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  return (
    <>
      <section className="bg-white aon-categories-area sf-curve-pos">
        <div className="container">
          {/*Title Section Start*/}
          <div className="section-head">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <span className="aon-sub-title">companies</span>
                <h2 className="aon-title">Popular Companies</h2>
              </div>
              <div className="col-lg-6 col-md-12">
                <p>
                  Experience innovation with standout software firms like
                  ByteWave and CodeNova. Their solutions redefine tech
                  boundaries. From QuantumQuotient's excellence to NexusByte's
                  integration, these companies deliver. Trust Innovacore Systems
                  and QuantumCraft for visionary growth in a digital age.
                </p>
              </div>
            </div>
          </div>
          {/*Title Section End*/}
          <div className="section-content">
            <div className="row">
              <Swiper
                className="pb-5"
                modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
                autoplay={{ delay: 5000 }}
                breakpoints={{
                  320: {
                    spaceBetween: 5,

                    slidesPerView: 2,
                  },

                  576: {
                    spaceBetween: 5,

                    slidesPerView: 3,
                  },
                  768: {
                    spaceBetween: 5,

                    slidesPerView: 4,
                  },
                  1024: {
                    spaceBetween: 10,
                    slidesPerView: 6,
                  },
                  1280: {
                    spaceBetween: 5,

                    slidesPerView: 6,
                  },
                }}
                pagination={{ clickable: true }}

              >
                {companies.length > 0 ? (
                  companies.map((company, index) => (
                    <SwiperSlide key={index}>
                      <div className="item col-lg-12">
                        <Link
                          className="shine-box"
                          to={`/company/${company?.id}`}
                        >
                          <div className="">
                            <div className="aon-cat-pic media-bg-animate shine-hover">
                              <img
                                style={{ height: "165px" }}
                                src={`${company?.logo
                                  ? api_url + "/" + company?.logo
                                  : noimage
                                  }`}
                                alt={noimage}
                              />
                            </div>
                            <h4 className="aon-cat-title s-18 fw-700 text-022279">
                              {company.name}
                            </h4>
                          </div>
                        </Link>
                      </div>
                    </SwiperSlide>
                  ))
                ) : (
                  <SwiperSlide>
                    <div className="item col-lg-12">
                      <div className="">
                        <div className="aon-cat-pic media-bg-animate shine-hover">
                          <a className="shine-box" href="/">
                            <img src={noimage} alt="" />
                          </a>
                        </div>
                        <h4 className="aon-cat-title s-18 fw-700 text-022279">
                          no record found!
                        </h4>
                      </div>
                    </div>
                  </SwiperSlide>
                )}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeCompanies;
